import type { PropsWithChildren } from 'react';
import { Sidebar, SidebarPage, SidebarItem, SidebarDivider, SidebarSpace } from '@backstage/core-components';
import { Settings } from '@backstage/plugin-user-settings';
import StorageIcon from '@material-ui/icons/Storage';
import AppsIcon from '@material-ui/icons/Apps';
import CodeIcon from '@material-ui/icons/Code';
import BookIcon from '@material-ui/icons/Book';

export function Root({ children }: PropsWithChildren<{}>) {
  return <SidebarPage>
    <Sidebar>
      <SidebarItem icon={StorageIcon} to="/cluster" text="Current cluster" />
      <SidebarDivider />
      <SidebarItem icon={AppsIcon} to="/catalog" text="Services" />
      <SidebarItem icon={CodeIcon} to="/api-docs" text="Protobuf APIs" />
      <SidebarItem icon={BookIcon} to="/docs" text="Documentation" />
      <SidebarSpace />
      <SidebarDivider />
      <Settings />
    </Sidebar>
    {children}
  </SidebarPage>;
}
